import * as icons from '@/store/static/base-icons'
import routeNames from './route-names'
import {VIEW_CUSTOMERS_CHARTS, VIEW_CUSTOMERS_LIST, VIEW_CUSTOMERS_METRICS} from '@/store/static/permissions/customers'
import {VIEW_CONTACT_LIST} from '@/store/static/permissions/contact'
import {VEW_CONTRACT_LIST} from '@/store/static/permissions/contract'
import {VIEW_INVOICE_LIST} from '@/store/static/permissions/invoice'
import {VIEW_CANCELLATION_LIST, VIEW_CANCELLATION_SUMMARY} from '@/store/static/permissions/cancellation'
import {VIEW_CATEGORY_LIST, VIEW_PRODUCT_METRIC_LIST, VIEW_PRODUCTS_LIST, VIEW_SUPPLIER_LIST} from '@/store/static/permissions/product'
import {VIEW_STAFF_MEMBER_LIST, VIEW_STAFF_SSO_LOGS} from '@/store/static/permissions/staff'
import {VIEW_SIPCENTRIC_CUSTOMER_LIST} from '@/store/static/permissions/sipcentric'
import {VIEW_TOOLS_REPORTS_LIST, VIEW_TOOLS_BESPOKES_LIST,VIEW_TOOLS_BUNDLES_LIST} from '@/store/static/permissions/tools'
import {VIEW_NUMBERS_LIST, IMPORT_NUMBER} from '@/store/static/permissions/reservation'

export default [
    {
        icon: icons.CUSTOMERS_ICON,
        title: 'Customer Management',
        to: {path: '/customers/customers'},
        meta: {subtitle: 'Customer Management'},
        exact: false,
        children: [
            {
                icon: icons.CUSTOMER_ICON,
                title: 'Customers',
                exact: false,
                to: {name: routeNames.customer.CUSTOMERS},
                permissions: [
                    VIEW_CUSTOMERS_LIST,
                    VIEW_CUSTOMERS_METRICS,
                    VIEW_CUSTOMERS_CHARTS
                ]
            },
            {
                icon: icons.CONTACT_ICON,
                title: 'Contacts',
                exact: false,
                to: {name: routeNames.contact.CONTACTS},
                permissions: [VIEW_CONTACT_LIST]
            },
            {
                icon: icons.CONTRACT_ICON,
                title: 'Contracts',
                exact: false,
                to: {name: routeNames.contract.CONTRACTS},
                permissions: [VEW_CONTRACT_LIST]
            },
            {
                icon: icons.INVOICE_ICON,
                title: 'Invoices',
                exact: false,
                to: {name: routeNames.invoice.INVOICES},
                permissions: [VIEW_INVOICE_LIST]
            },
            {
                icon: icons.CANCELLATION_ICON,
                title: 'Cancellations',
                exact: false,
                to: {name: routeNames.cancellation.CANCELLATIONS_SUMMARY},
                permissions: [VIEW_CANCELLATION_LIST, VIEW_CANCELLATION_SUMMARY]
            }
        ]
    },
    {
        icon: icons.PRODUCTS_ICON,
        title: 'Products',
        to: {path: '/products'},
        meta: {subtitle: 'Products'},
        exact: false,
        children: [
            {
                icon: icons.PRODUCT_INVENTORY_ICON,
                title: 'Product Inventory',
                exact: false,
                to: {name: routeNames.productInventory.INVENTORY_PRODUCTS},
                permissions: [
                    VIEW_PRODUCTS_LIST,
                    VIEW_CATEGORY_LIST,
                    VIEW_SUPPLIER_LIST,
                    VIEW_PRODUCT_METRIC_LIST
                ]
            },
            // {
            //     icon: icons.CONNECTIVITY_CHECKER_ICON,
            //     title: 'Connectivity Quotes',
            //     exact: false,
            //     to: {name: routeNames.connectivityChecker.CONNECTIVITY_QUOTE}
            // }
        ]
    },
    {
        icon: icons.RESERVATION_ICON,
        title: 'Numbers Management',
        to: {path: '/reservation/numbers'},
        meta: {subtitle: 'Numbers Management'},
        exact: false,
        children: [
            {
                icon: icons.RESERVATION_ICON,
                title: 'Numbers',
                exact: false,
                to: {name: routeNames.reservation.RESERVATION_NUMBERS},
                permissions: [VIEW_NUMBERS_LIST]
            },
            {
                icon: icons.RESERVATION_IMPORT_ICON,
                title: 'Import',
                exact: false,
                to: {name: routeNames.reservation.RESERVATION_NUMBER_IMPORT},
                permissions: [IMPORT_NUMBER]
            }
        ]
    },
    {
        icon: icons.STAFF_MEMBERS_ICON,
        title: 'Staff Management',
        to: {path: '/staff-members'},
        meta: {subtitle: 'Staff Management'},
        exact: false,
        children: [
            {
                icon: icons.STAFF_MEMBER_ICON,
                title: 'Staff Members',
                exact: false,
                to: {name: routeNames.staffMember.STAFF_MEMBERS},
                permissions: [VIEW_STAFF_MEMBER_LIST, VIEW_STAFF_SSO_LOGS]
            }
        ]
    },
    {
        icon: icons.SIPCENTRIC_ICON,
        title: 'Sipcentric',
        to: {path: '/sipcentric/customers'},
        meta: {subtitle: 'Sipcentric'},
        exact: false,
        children: [
            {
                icon: icons.CUSTOMER_ICON,
                title: 'Customers',
                exact: false,
                to: {name: routeNames.sipcentric.CUSTOMERS},
                permissions: [VIEW_SIPCENTRIC_CUSTOMER_LIST]
            }
        ]
    },
    {
        icon: icons.STAFF_MEMBER_ICON,
        title: 'Tools',
        to: {path: '/tools/scheduled-reports/bundles'},
        meta: {subtitle: 'Tools'},
        exact: false,
        children: [
            {
                icon: icons.SIPCENTRIC_ICON,
                title: 'Scheduled Reports',
                exact: false,
                to: {name: routeNames.scheduledReport.SCHEDULED_BUNDLES},
                permissions: [VIEW_TOOLS_REPORTS_LIST]
            },
            {
                icon: icons.PRODUCT_INVENTORY_ICON,
                title: 'Bespoke Reports',
                exact: false,
                to: {name: routeNames.bespoke.BESPOKES},
                permissions: [VIEW_TOOLS_BESPOKES_LIST]
            },
            {
                icon: icons.INVOICE_ICON,
                title: 'Bundles Reports',
                exact: false,
                to: {name: routeNames.bundle.BUNDLES},
                permissions: [VIEW_TOOLS_BUNDLES_LIST]
            },
        ]
    },
    {
        icon: icons.HELP_ICON,
        title: 'Help & Support',
        href: process.env.VUE_APP_KNOWLEDGE_BASE_URL,
        target: '_blank'
    }
]
